import Vue from 'vue'
export default new Vue


// WEBPACK FOOTER //
// ./src/js/utils.js